import BuildingType from '@/roc/building/BuildingType';
import Effects from '@/roc/effects/Effects';
import ProductionOutputType from '@/roc/effects/Production/ProductionOutputType';
import PassiveAura from '@/roc/effects/PassiveAura/PassiveAura';
import PassiveAuraType from '@/roc/effects/PassiveAura/PassiveAuraType';
import EffectAmount from '@/roc/effects/EffectAmount';
import PassiveProduction from '@/roc/effects/Production/PassiveProduction';
import ProductionDuration from '@/roc/effects/Production/ProductionDuration';
import ProductionOutput from '@/roc/effects/Production/ProductionOutput';

const HotAirBalloon = {
  id: '76',
  name: "Hot Air Balloon",
  width: 4,
  height: 3,
  type: BuildingType.EVENT,
  era: 'stoneAge',
  icon: 'Hot_Air_Balloon',
  minLevel: 1,
  maxLevel: 60,
  url: 'https://riseofcultures.wiki.gg/wiki/Buildings/Hot_Air_Balloon',
  flags: 0,
  counts: null,
  effects: Effects.create([
    new PassiveAura(
      PassiveAuraType.RANGED_HIT_POINT_MOD,
      EffectAmount.asPerLevel([
        1.5, 1.5, 1.5, 2.0, 2.0, 2.5, 2.5, 2.5, 3.0, 3.0,
        3.5, 3.5, 3.5, 4.0, 4.0, 4.5, 4.5, 4.5, 5.0, 5.0,
        5.5, 5.5, 5.5, 6.0, 6.0, 6.5, 6.5, 6.5, 7.0, 7.0,
        7.5, 7.5, 7.5, 8.0, 8.0, 8.5, 8.5, 8.5, 9.0, 9.1,
        9.2, 9.4, 9.5, 9.6, 9.8, 9.9, 10.0, 10.1, 10.2, 10.4,
        10.5, 10.6, 10.8, 10.9, 11.0, 11.1, 11.2, 11.4, 11.5, 11.6
      ]),
      '%',
    ),
    new PassiveProduction(
      ProductionDuration.asDaily(),
      ProductionOutput.asCallbackWithLevel((level) => {
        if (level === 1) return 0;
        if (level <= 6) return 1;
        if (level <= 11) return 2;
        if (level <= 16) return 3;
        if (level <= 21) return 4;
        if (level <= 26) return 5;
        if (level <= 31) return 6;
        if (level <= 36) return 7;
        if (level <= 41) return 8;
        if (level <= 46) return 9;
        if (level <= 51) return 10;
        if (level <= 56) return 11;
        return 12
      }).withOutput(ProductionOutputType.RESEARCH_POINTS),
    ),
    new PassiveProduction(
      ProductionDuration.asDaily(),
      ProductionOutput.asPerEraAndLevel({
        stoneAge: [
          0,0,50,50,105,105,105,125,125,150,150,150,180,180,195,195,195,210,210,240,240,240,255,255,270,270,270,285,285,300,300,300,315,315,330,330,330,345,345,360,370,380,390,400,410,420,430,440,450,460,470,480,490,500,510,520,530,540,550,560
        ],
        bronzeAge: [
          0,0,50,50,105,105,105,125,125,150,150,150,180,180,195,195,195,210,210,240,240,240,255,255,270,270,270,285,285,300,300,300,315,315,330,330,330,345,345,360,370,380,390,400,410,420,430,440,450,460,470,480,490,500,510,520,530,540,550,560
        ],
        minoanEra: [
          0,0,75,75,150,150,150,180,180,210,210,210,255,255,270,270,270,300,300,330,330,330,345,345,360,360,360,375,375,400,400,400,420,420,450,450,450,480,480,510,530,550,570,590,610,630,650,670,690,710,730,750,770,790,810,830,850,870,890,910
        ],
        classicGreece: [
          0,0,120,120,240,240,240,285,285,330,330,330,405,405,435,435,435,480,480,525,525,525,560,560,600,600,600,640,640,675,675,675,710,710,750,750,750,790,790,825,850,875,900,925,950,975,1000,1025,1050,1075,1100,1125,1150,1175,1200,1225,1250,1275,1300,1325
        ],
        earlyRome: [
          0,0,150,150,270,270,270,345,345,405,405,405,465,465,525,525,525,570,570,645,645,645,675,675,720,720,720,750,750,780,780,780,825,825,870,870,870,915,915,960,990,1020,1050,1080,1110,1140,1170,1200,1230,1260,1290,1320,1350,1380,1410,1440,1470,1500,1530,1560
        ],
        romanEmpire: [
          0,0,180,180,300,300,300,375,375,450,450,450,525,525,600,600,600,675,675,750,750,750,825,825,900,900,900,960,960,1020,1020,1020,1080,1080,1140,1140,1140,1200,1200,1260,1300,1340,1380,1420,1460,1500,1540,1580,1620,1660,1700,1740,1780,1820,1860,1900,1940,1980,2020,2060
        ],
        byzantineEra: [
          0,0,180,180,300,300,300,375,375,450,450,450,525,525,600,600,600,675,675,750,750,750,825,825,900,900,900,960,960,1020,1020,1020,1080,1080,1140,1140,1140,1200,1200,1260,1300,1340,1380,1420,1460,1500,1540,1580,1620,1660,1700,1740,1780,1820,1860,1900,1940,1980,2020,2060
        ],
        ageOfTheFranks: [
          0,0,180,180,300,300,300,375,375,450,450,450,525,525,600,600,600,675,675,750,750,750,825,825,900,900,900,960,960,1020,1020,1020,1080,1080,1140,1140,1140,1200,1200,1260,1300,1340,1380,1420,1460,1500,1540,1580,1620,1660,1700,1740,1780,1820,1860,1900,1940,1980,2020,2060
        ],
        feudalAge: [
          0,0,180,180,300,300,300,375,375,450,450,450,525,525,600,600,600,675,675,750,750,750,825,825,900,900,900,960,960,1020,1020,1020,1080,1080,1140,1140,1140,1200,1200,1260,1300,1340,1380,1420,1460,1500,1540,1580,1620,1660,1700,1740,1780,1820,1860,1900,1940,1980,2020,2060
        ],
        iberianEra: [
          0,0,180,180,300,300,300,375,375,450,450,450,525,525,600,600,600,675,675,750,750,750,825,825,900,900,900,960,960,1020,1020,1020,1080,1080,1140,1140,1140,1200,1200,1260,1300,1340,1380,1420,1460,1500,1540,1580,1620,1660,1700,1740,1780,1820,1860,1900,1940,1980,2020,2060
        ],
        kingdomOfSicily: [
          0,0,180,180,300,300,300,375,375,450,450,450,525,525,600,600,600,675,675,750,750,750,825,825,900,900,900,960,960,1020,1020,1020,1080,1080,1140,1140,1140,1200,1200,1260,1300,1340,1380,1420,1460,1500,1540,1580,1620,1660,1700,1740,1780,1820,1860,1900,1940,1980,2020,2060
        ],
        highMiddleAges: [
          0,0,180,180,300,300,300,375,375,450,450,450,525,525,600,600,600,675,675,750,750,750,825,825,900,900,900,960,960,1020,1020,1020,1080,1080,1140,1140,1140,1200,1200,1260,1300,1340,1380,1420,1460,1500,1540,1580,1620,1660,1700,1740,1780,1820,1860,1900,1940,1980,2020,2060
        ],
        earlyGothicEra: [
          0,0,180,180,300,300,300,375,375,450,450,450,525,525,600,600,600,675,675,750,750,750,825,825,900,900,900,960,960,1020,1020,1020,1080,1080,1140,1140,1140,1200,1200,1260,1300,1340,1380,1420,1460,1500,1540,1580,1620,1660,1700,1740,1780,1820,1860,1900,1940,1980,2020,2060
        ],
        lateGothicEra: [
          0,0,180,180,300,300,300,375,375,450,450,450,525,525,600,600,600,675,675,750,750,750,825,825,900,900,900,960,960,1020,1020,1020,1080,1080,1140,1140,1140,1200,1200,1260,1300,1340,1380,1420,1460,1500,1540,1580,1620,1660,1700,1740,1780,1820,1860,1900,1940,1980,2020,2060
        ]
      }).withOutput(ProductionOutputType.CURRENT_ERA_TERTIARY_GOODS),
    ),
  ]),
};

export default HotAirBalloon;
